
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 2.406a.255.255 0 00-.438-.187l-.75.781C10.5 4.375 8.813 5.344 7 5.75v5.531a9.383 9.383 0 014.813 2.75l.75.781c.156.157.437.032.437-.187V2.406zm-7 8.719V5.906c-.188.032-.375.032-.563.063L4.5 6H2c-.563 0-1 .469-1 1v3c0 .563.438 1 1 1h2.5l.938.063c.187 0 .375.03.562.062zm5.844-9.594C12.594.72 14 1.25 14 2.406v12.219c0 1.125-1.406 1.688-2.156.875l-.75-.781A8.538 8.538 0 006 12.125v3.125C6 16.219 5.219 17 4.25 17h-.5C2.781 17 2 16.219 2 15.25V12c-1.125 0-2-.875-2-2V7c0-1.094.875-2 2-2h2.469l.906-.031a8.477 8.477 0 005.719-2.657l.75-.78zM3 12v3.25c0 .438.313.75.75.75h.5a.74.74 0 00.75-.75v-3.219L4.469 12H3zm12.5-5c.25 0 .5.25.5.5v2c0 .281-.25.5-.5.5a.494.494 0 01-.5-.5v-2c0-.25.219-.5.5-.5z","fill":"#212121"}})])
          )
        }
      }
    